import { CrewMember } from '../../data/types/crew-member/crew-member';
import { skillTypes } from '../../data/types/crew-member/skill';
import { add } from 'ramda';

export function mercenaryHirePrice({ skills }: CrewMember): number {
  return skillTypes.map((skillType) => skills[skillType]).reduce(add, 0) * 3;
}
